<template>
  <div>
    <mt-header title="馆内推荐">
      <router-link to="/" slot="left">返回</router-link>
    </mt-header>
    <div class="wrap" ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
      <mt-loadmore
        :top-method="loadTop"
        :bottom-method="loadBottom"
        :bottom-all-loaded="allLoaded"
        ref="loadmore"
      >
        <div @click="linkTo(item)" v-for="(item,index) in twList" :key="index" class="wrap-item">
          <div class="info-wrap">
            <p class="title">{{item.article_theme ? item.article_theme : '暂无名称'}}</p>
          </div>
          <img :src="twBG" alt />
        </div>
      </mt-loadmore>
      <div v-show="hasAll" class="info">已经加载全部</div>
    </div>
  </div>
</template>
<script>
import twBG from "../assets/img/tw1.png";
import { tweetList,insInfo } from "@/api/api.js";
import { isEmpty } from "@/utils/util.js";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      twBG,
      twList: [],
      page: 1,
      pagesize: 20,
      allLoaded: false,

      hasAll: false,

      wrapperHeight: 0,
      org_id: "",
    };
  },
  mounted() {
    insInfo().then((res) => {
      this.org_id = res.instanceInfo.orgInfo.orgId;
      this.tweetListHandle();
    });
    
    this.wrapperHeight =
      document.documentElement.clientHeight -
      this.$refs.wrapper.getBoundingClientRect().top;
  },

  methods: {
    async tweetListHandle() {
      const res = await tweetList({
        page: this.page,
        pagesize: this.pagesize,
        org_id: this.org_id,
      });

      let resList = [];
      if (res.list.length == 0) {
        this.hasAll = true;
      }
      res.list &&
        res.list.forEach((item) => {
          if (item.is_publish == 1) {
            resList.push(item);
          }
        });
      this.allLoaded = false; // 若数据已全部获取完毕

      this.twList = [...resList, ...this.twList];
    },
    loadTop() {
      this.hasAll = false;
      this.twList = [];
      this.page = 1;
      this.tweetListHandle();

      this.$refs.loadmore.onTopLoaded();
    },
    loadBottom() {
      if (this.hasAll) {
        // Toast("已加载全部");
        this.allLoaded = true; // 若数据已全部获取完毕
        return;
      }
      this.page += 1;
      this.tweetListHandle();
      this.allLoaded = true; // 若数据已全部获取完毕
      this.$refs.loadmore.onBottomLoaded();
    },
    linkTo(item) {
      if (isEmpty(item.article_link)) {
        Toast("没有配置相关链接");
        return;
      }
      window.location.href = item.article_link;
    },
  },
};
</script>
<style lang="less" scope>
.wrap {
  padding: 20px;
  background-color: #eee;
  // overflow: scroll;
  overflow-y: scroll;
  .wrap-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 200px;
    padding: 20px;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 20px;
    // box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.2);
    img {
      width: 160px;
      height: 160px;
    }
    .info-wrap {
      flex: 1;
      margin-left: 20px;
      .title {
        font-size: 0.4rem;
        font-weight: 600;
        margin-bottom: 20px;
      }
    }
  }
}
.mint-loadmore {
  height: 100%;
  overflow-y: scroll;
}
.info {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>